import React from 'react';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { FileSpreadsheet } from 'lucide-react';
import { formatCell } from '../../utils/reportExport';

const isNum = (t) => t === 'currency' || t === 'number';

export const ReportSummary = ({ report }) => (
  <div className="flex flex-wrap gap-3" data-testid="report-summary">
    {(report.summary || []).map(s => (
      <div key={s.label} className="px-4 py-2 rounded-lg bg-slate-50 border border-slate-200">
        <div className="text-[11px] uppercase tracking-wide text-slate-500">{s.label}</div>
        <div className="text-sm font-semibold text-slate-900">{s.value}</div>
      </div>
    ))}
    {Object.entries(report.totals || {}).map(([k, v]) => {
      const c = report.columns.find(col => col.key === k);
      return (
        <div key={k} className="px-4 py-2 rounded-lg bg-blue-50 border border-blue-100" data-testid={`report-total-${k}`}>
          <div className="text-[11px] uppercase tracking-wide text-blue-600">Total {c?.label}</div>
          <div className="text-sm font-semibold text-blue-900">{c?.type === 'currency' ? '₹' : ''}{formatCell(v, c?.type)}</div>
        </div>
      );
    })}
  </div>
);

export const ReportTable = ({ report }) => {
  if (!report.rows.length) {
    return (
      <div className="py-16 text-center text-slate-500" data-testid="report-empty">
        <FileSpreadsheet className="mx-auto mb-3 text-slate-300" size={40} />
        No records found for the selected filters
      </div>
    );
  }
  const hasTotals = Object.keys(report.totals || {}).length > 0;
  return (
    <div className="border rounded-lg overflow-auto max-h-[60vh]" data-testid="report-table">
      <Table>
        <TableHeader className="sticky top-0 bg-slate-100 z-10">
          <TableRow>
            {report.columns.map(c => (
              <TableHead key={c.key} className={`whitespace-nowrap ${isNum(c.type) ? 'text-right' : ''}`}>{c.label}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {report.rows.map((r, i) => (
            <TableRow key={i} data-testid={`report-row-${i}`}>
              {report.columns.map(c => (
                <TableCell key={c.key} className={`text-sm ${isNum(c.type) ? 'text-right tabular-nums' : ''} ${c.key === 'serials' ? 'max-w-xs break-words' : 'whitespace-nowrap'}`}>
                  {formatCell(r[c.key], c.type)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
        {hasTotals && (
          <TableFooter className="sticky bottom-0 bg-slate-100">
            <TableRow data-testid="report-totals-row">
              {report.columns.map((c, i) => (
                <TableCell key={c.key} className={`font-semibold ${isNum(c.type) ? 'text-right tabular-nums' : ''}`}>
                  {i === 0 ? 'TOTAL' : (c.key in report.totals ? formatCell(report.totals[c.key], c.type) : '')}
                </TableCell>
              ))}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </div>
  );
};
